import { PrimaryContentType, TrailingContentType } from "../AmorgMenuTypes";

export function getFlex(primary:PrimaryContentType, trailing:TrailingContentType)
{
    let primaryContentFlex = '1 1 0%';
    if(trailing.type === 'text')
        primaryContentFlex = '0.7 1 0%';
    if(primary.flex)
        primaryContentFlex = primary.flex;

    let trailingContentFlex = '0.3 1 0%';
    if(trailing.type === 'text' && trailing.flex)
        trailingContentFlex = trailing.flex;

    return {primaryContentFlex, trailingContentFlex};
}